export default () => !!(!(document.documentMode) && !!window.StyleMedia)
